import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layers, ArrowRight } from 'lucide-react';
import api from './axiosConfig';

// 🎯 قايمة الشاشات المسجّلة كـ "قابلة للتوسيع" (EXTENDABLE_SCREENS في
// main.py) - اختيار شاشة هنا يودّي لاستوديو مصغّر يضيف حقول جواها في مكان
// حقيقي (تاب/سكشن)، مش تاب منفصل مبتور
const ExtendScreenList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [screens, setScreens] = useState({});
  const [counts, setCounts] = useState({});

  const load = useCallback(async () => {
    const res = await api.get('/custom-fields/anchors');
    setScreens(res.data || {});
    Object.keys(res.data || {}).forEach((key) => {
      api.get('/custom-fields', { params: { core_model_name: key } })
        .then((r) => setCounts((prev) => ({ ...prev, [key]: (r.data || []).length })))
        .catch(() => {});
    });
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="flex flex-col h-full bg-surface-app p-6">
      <h2 className="text-primary font-black italic uppercase text-lg tracking-tighter mb-1 flex items-center gap-2">
        <Layers size={20} /> {t('customApps.extendScreens.title', 'Extend Existing Screens')}
      </h2>
      <p className="text-[11px] text-gray-400 font-bold mb-6">
        {t('customApps.extendScreens.subtitle', 'Add custom fields that render inline inside a real, existing screen')}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Object.entries(screens).map(([key, screen]) => (
          <button
            key={key}
            onClick={() => navigate(`/admin/custom-apps/extend/${key}`)}
            className="bg-surface-card border border-line rounded-lg p-4 text-left hover:border-primary hover:shadow-card transition-all group"
          >
            <div className="flex items-center justify-between">
              <span className="font-black text-ink uppercase text-sm">{screen.label}</span>
              <ArrowRight size={16} className="text-gray-300 group-hover:text-primary transition-colors" />
            </div>
            <span className="text-[10px] font-bold text-gray-400 uppercase mt-1 block">
              {counts[key] ?? '…'} {t('customApps.extendScreens.fieldsAdded', 'custom fields added')}
            </span>
          </button>
        ))}
        {Object.keys(screens).length === 0 && (
          <div className="text-[11px] text-gray-400 font-bold uppercase">
            {t('customApps.extendScreens.none', 'No screens are registered as extendable yet')}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExtendScreenList;
